import { render, staticRenderFns } from "./prijstabellen.vue?vue&type=template&id=188c9492&"
import script from "./prijstabellen.vue?vue&type=script&lang=js&"
export * from "./prijstabellen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports